export const selector = (state) => {
  return state.user.currentUser;
};
